window.toggle_leave_question = function()
{
    if (document.getElementById('leave_question').checked === true) {
        $('#member_question').css('display', 'inline')
    } else {
        $('#member_question').css('display', 'none');
    }
}
